import {createSelector} from 'reselect';

import type {NutshellState} from '../../../store';

import type {CoreEntityPageState, CreatorForm, TabOption} from './types';

export const getCoreEntityPageState = (state: NutshellState): CoreEntityPageState =>
    state.coreEntityPage;

export const getCoreEntityPageCreatorForm = createSelector<
    NutshellState,
    CoreEntityPageState,
    CreatorForm
>([getCoreEntityPageState], (coreEntityPageState) => coreEntityPageState.creatorForm);

export const getCoreEntityPageActionBarTab = createSelector<
    NutshellState,
    CoreEntityPageState,
    TabOption
>([getCoreEntityPageState], (coreEntityPageState) => coreEntityPageState.actionBarTab);
